import LoadingActionButton from "server/components/LoadingActionButton";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import { settings } from "app";
import { candidateRequests } from "api/candidateApi";
import { getFileFromUrl } from "server/components/DownloadFile";
import { useNotify } from "react-admin";
import { useCallback, useState } from "react";

const ExamResultsTemplateButton = () => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const downloadTemplate = useCallback(async () => {
    setLoading(true);

    const fileName = "exam-results-template.xlsx";

    await getFileFromUrl(
      `${settings.gatewayApi}/${candidateRequests.getCampaignExamResultsTemplate()}`,
      fileName,
      notify,
    );

    setLoading(false);
  }, [notify]);

  return (
    <LoadingActionButton
      label="Изтегли шаблон"
      icon={<HistoryEduIcon />}
      onClick={downloadTemplate}
      loading={loading}
    />
  );
};

export default ExamResultsTemplateButton;
